!(function (e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t(require('angular/index')))
    : 'function' == typeof define && define.amd
    ? define(['angular'], t)
    : 'object' == typeof exports
    ? (exports.angularCacheModuleName = t(require('angular')))
    : (e.angularCacheModuleName = t(e.angular));
})(this, function (e) {
  return (function (e) {
    function t(i) {
      if (r[i]) return r[i].exports;
      var n = (r[i] = { exports: {}, id: i, loaded: !1 });
      return e[i].call(n.exports, n, n.exports, t), (n.loaded = !0), n.exports;
    }
    var r = {};
    return (t.m = e), (t.c = r), (t.p = ''), t(0);
  })([
    function (e, t, r) {
      function i(e, t, r) {
        for (var i = e[r], n = t(i); r > 0; ) {
          var s = Math.floor((r + 1) / 2) - 1,
            o = e[s];
          if (n >= t(o)) break;
          (e[s] = i), (e[r] = o), (r = s);
        }
      }
      var n = function (e) {
          return e && e.__esModule ? e['default'] : e;
        },
        s = function (e, t) {
          if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
        },
        o = n(r(1)),
        a = function (e) {
          var t = [],
            r = void 0;
          for (r in e) e.hasOwnProperty(r) && t.push(r);
          return t;
        },
        c = function (e) {
          return e && 'function' == typeof e.then;
        },
        l = function (e) {
          return o.isNumber(e) ? e.toString() : e;
        },
        u = function (e) {
          var t,
            r = {};
          for (t in e) e.hasOwnProperty(t) && (r[t] = t);
          return r;
        },
        h = function (e, t, r) {
          for (var i = e.length, n = e[r], s = t(n); ; ) {
            var o = 2 * (r + 1),
              a = o - 1,
              c = null;
            if (i > a) {
              var l = e[a],
                u = t(l);
              s > u && (c = a);
            }
            if (i > o) {
              var h = e[o],
                f = t(h);
              f < (null === c ? s : t(e[a])) && (c = o);
            }
            if (null === c) break;
            (e[r] = e[c]), (e[c] = n), (r = c);
          }
        },
        f = function m(e, t) {
          var r = this;
          if (
            (s(this, m),
            e ||
              (e = function (e) {
                return e;
              }),
            t ||
              (t = function (e, t) {
                return e === t;
              }),
            'function' != typeof e)
          )
            throw new Error('BinaryHeap([weightFunc][, compareFunc]): "weightFunc" must be a function!');
          if ('function' != typeof t)
            throw new Error('BinaryHeap([weightFunc][, compareFunc]): "compareFunc" must be a function!');
          (this.weightFunc = e),
            (this.compareFunc = t),
            (this.heap = []),
            (this.push = function (e) {
              r.heap.push(e), i(r.heap, r.weightFunc, r.heap.length - 1);
            }),
            (this.peek = function () {
              return r.heap[0];
            }),
            (this.pop = function () {
              var e = r.heap[0],
                t = r.heap.pop();
              return r.heap.length > 0 && ((r.heap[0] = t), h(r.heap, r.weightFunc, 0)), e;
            }),
            (this.remove = function (e) {
              for (var t = r.heap.length, n = 0; t > n; n++)
                if (r.compareFunc(r.heap[n], e)) {
                  var s = r.heap[n],
                    o = r.heap.pop();
                  return n !== t - 1 && ((r.heap[n] = o), i(r.heap, r.weightFunc, n), h(r.heap, r.weightFunc, n)), s;
                }
              return null;
            }),
            (this.removeAll = function () {
              r.heap = [];
            }),
            (this.size = function () {
              return r.heap.length;
            });
        },
        p = function v() {
          s(this, v),
            (this.$get = function () {
              return f;
            });
        },
        $ = function d() {
          var e = this;
          s(this, d);
          var t = (this.defaults = {
            capacity: Number.MAX_VALUE,
            maxAge: Number.MAX_VALUE,
            deleteOnExpire: 'none',
            onExpire: null,
            cacheFlushInterval: null,
            recycleFreq: 1e3,
            storageMode: 'memory',
            storageImpl: null,
            disabled: !1,
            storagePrefix: 'angular-cache.caches.',
            storeOnResolve: !1,
            storeOnReject: !1
          });
          this.$get = [
            '$q',
            function (r) {
              function i(e, t) {
                return s(e, t);
              }
              var n = {},
                s = function (e, i) {
                  if (e in n) throw new Error('' + e + ' already exists!');
                  if (!o.isString(e)) throw new Error('cacheId must be a string!');
                  var s = {},
                    h = {},
                    p = null,
                    $ = new f(function (e) {
                      return e.expires;
                    }, o.equals),
                    m = new f(function (e) {
                      return e.accessed;
                    }, o.equals),
                    v = (n[e] = {
                      $$id: e,
                      destroy: function () {
                        clearInterval(this.$$cacheFlushIntervalId),
                          clearInterval(this.$$recycleFreqId),
                          this.removeAll(),
                          p && (p().removeItem('' + this.$$prefix + '.keys'), p().removeItem(this.$$prefix)),
                          (p = null),
                          (s = null),
                          (m = null),
                          ($ = null),
                          (this.$$prefix = null),
                          delete n[this.$$id];
                      },
                      disable: function () {
                        this.$$disabled = !0;
                      },
                      enable: function () {
                        delete this.$$disabled;
                      },
                      get: function (e, t) {
                        var r = this;
                        if (o.isArray(e)) {
                          var i = (function () {
                            var i = e,
                              n = [];
                            return (
                              o.forEach(i, function (e) {
                                var i = r.get(e, t);
                                null !== i && void 0 !== i && n.push(i);
                              }),
                              { v: n }
                            );
                          })();
                          if ('object' == typeof i) return i.v;
                        } else if (((e = l(e)), this.$$disabled)) return;
                        if (((t = t || {}), !o.isString(e))) throw new Error('key must be a string!');
                        if (t && !o.isObject(t)) throw new Error('options must be an object!');
                        if (t.onExpire && !o.isFunction(t.onExpire))
                          throw new Error('options.onExpire must be a function!');
                        var n = void 0;
                        if (p) {
                          if (h[e]) return h[e];
                          var a = p().getItem('' + this.$$prefix + '.data.' + e);
                          if (!a) return;
                          n = o.fromJson(a);
                        } else {
                          if (!(e in s)) return;
                          n = s[e];
                        }
                        var c = n.value,
                          u = new Date().getTime();
                        return (
                          p
                            ? (m.remove({ key: e, accessed: n.accessed }),
                              (n.accessed = u),
                              m.push({ key: e, accessed: u }))
                            : (m.remove(n), (n.accessed = u), m.push(n)),
                          'passive' === this.$$deleteOnExpire && 'expires' in n && n.expires < u
                            ? (this.remove(e),
                              this.$$onExpire
                                ? this.$$onExpire.call(this, e, n.value, t.onExpire)
                                : t.onExpire && t.onExpire.call(this, e, n.value),
                              (c = void 0))
                            : p && p().setItem('' + this.$$prefix + '.data.' + e, JSON.stringify(n)),
                          c
                        );
                      },
                      info: function (e) {
                        if (e) {
                          var t = void 0;
                          if (p) {
                            var r = p().getItem('' + this.$$prefix + '.data.' + e);
                            return r
                              ? ((t = o.fromJson(r)),
                                {
                                  created: t.created,
                                  accessed: t.accessed,
                                  expires: t.expires,
                                  isExpired: new Date().getTime() - t.created > this.$$maxAge
                                })
                              : void 0;
                          }
                          return e in s
                            ? ((t = s[e]),
                              {
                                created: t.created,
                                accessed: t.accessed,
                                expires: t.expires,
                                isExpired: new Date().getTime() - t.created > this.$$maxAge
                              })
                            : void 0;
                        }
                        return {
                          id: this.$$id,
                          capacity: this.$$capacity,
                          maxAge: this.$$maxAge,
                          deleteOnExpire: this.$$deleteOnExpire,
                          onExpire: this.$$onExpire,
                          cacheFlushInterval: this.$$cacheFlushInterval,
                          recycleFreq: this.$$recycleFreq,
                          storageMode: this.$$storageMode,
                          storageImpl: p ? p() : void 0,
                          disabled: !!this.$$disabled,
                          size: (m && m.size()) || 0
                        };
                      },
                      keys: function () {
                        if (p) {
                          var e = p().getItem('' + this.$$prefix + '.keys');
                          return e ? o.fromJson(e) : [];
                        }
                        return a(s);
                      },
                      keySet: function () {
                        if (p) {
                          var e = p().getItem('' + this.$$prefix + '.keys'),
                            t = {};
                          if (e) for (var r = o.fromJson(e), i = 0; i < r.length; i++) t[r[i]] = r[i];
                          return t;
                        }
                        return u(s);
                      },
                      put: function (e, t, i) {
                        var n = this;
                        i = i || {};
                        var a = 'storeOnResolve' in i ? !!i.storeOnResolve : this.$$storeOnResolve,
                          u = 'storeOnReject' in i ? !!i.storeOnReject : this.$$storeOnReject,
                          f = function (t, i) {
                            return function (s) {
                              return (
                                t &&
                                  (delete h[e],
                                  o.isObject(s) && 'status' in s && 'data' in s
                                    ? ((s = [s.status, s.data, s.headers(), s.statusText]), n.put(e, s))
                                    : n.put(e, s)),
                                i ? r.reject(s) : s
                              );
                            };
                          };
                        if (!this.$$disabled && null !== t && void 0 !== t) {
                          if (((e = l(e)), !o.isString(e))) throw new Error('key must be a string!');
                          var v = new Date().getTime(),
                            d = { key: e, value: c(t) ? t.then(f(a, !1), f(u, !0)) : t, created: v, accessed: v };
                          if (((d.expires = d.created + this.$$maxAge), p)) {
                            if (c(d.value)) return (h[e] = d.value), h[e];
                            var g = p().getItem('' + this.$$prefix + '.keys'),
                              x = g ? o.fromJson(g) : [],
                              y = p().getItem('' + this.$$prefix + '.data.' + e);
                            y && this.remove(e),
                              $.push({ key: e, expires: d.expires }),
                              m.push({ key: e, accessed: d.accessed }),
                              p().setItem('' + this.$$prefix + '.data.' + e, JSON.stringify(d));
                            for (var E = !1, I = 0; I < x.length; I++)
                              if (x[I] === e) {
                                E = !0;
                                break;
                              }
                            E || x.push(e), p().setItem('' + this.$$prefix + '.keys', JSON.stringify(x));
                          } else s[e] && this.remove(e), $.push(d), m.push(d), (s[e] = d), delete h[e];
                          return m.size() > this.$$capacity && this.remove(m.peek().key), t;
                        }
                      },
                      remove: function (e) {
                        if (((e += ''), delete h[e], !p)) {
                          var t = s[e] ? s[e].value : void 0;
                          return m.remove(s[e]), $.remove(s[e]), (s[e] = null), delete s[e], t;
                        }
                        var r = p().getItem('' + this.$$prefix + '.data.' + e);
                        if (r) {
                          var i = o.fromJson(r);
                          m.remove({ key: e, accessed: i.accessed }),
                            $.remove({ key: e, expires: i.expires }),
                            p().removeItem('' + this.$$prefix + '.data.' + e);
                          var n = p().getItem('' + this.$$prefix + '.keys'),
                            a = n ? o.fromJson(n) : [],
                            c = a.indexOf(e);
                          return (
                            c >= 0 && a.splice(c, 1),
                            p().setItem('' + this.$$prefix + '.keys', JSON.stringify(a)),
                            i.value
                          );
                        }
                      },
                      removeAll: function () {
                        if (p) {
                          m.removeAll(), $.removeAll();
                          var e = p().getItem('' + this.$$prefix + '.keys');
                          if (e) for (var t = o.fromJson(e), r = 0; r < t.length; r++) this.remove(t[r]);
                          p().setItem('' + this.$$prefix + '.keys', JSON.stringify([]));
                        } else {
                          m.removeAll(), $.removeAll();
                          for (var i in s) s[i] = null;
                          s = {};
                        }
                      },
                      removeExpired: function () {
                        for (
                          var e = new Date().getTime(), t = {}, r = void 0, i = void 0;
                          (i = $.peek()) && i.expires <= e;

                        )
                          (t[i.key] = i.value ? i.value : null), $.pop();
                        if (p)
                          for (r in t) {
                            var n = p().getItem('' + this.$$prefix + '.data.' + r);
                            n && ((t[r] = o.fromJson(n).value), this.remove(r));
                          }
                        else for (r in t) this.remove(r);
                        if (this.$$onExpire) for (r in t) this.$$onExpire.call(this, r, t[r]);
                        return t;
                      },
                      setCacheFlushInterval: function (e) {
                        if (null === e) delete this.$$cacheFlushInterval;
                        else {
                          if (!o.isNumber(e)) throw new Error('cacheFlushInterval must be a number!');
                          if (0 > e) throw new Error('cacheFlushInterval must be greater than zero!');
                          e !== this.$$cacheFlushInterval &&
                            ((this.$$cacheFlushInterval = e),
                            clearInterval(this.$$cacheFlushIntervalId),
                            (function (e) {
                              e.$$cacheFlushIntervalId = setInterval(function () {
                                e.removeAll();
                              }, e.$$cacheFlushInterval);
                            })(this));
                        }
                      },
                      setCapacity: function (e) {
                        if (null === e) delete this.$$capacity;
                        else {
                          if (!o.isNumber(e)) throw new Error('capacity must be a number!');
                          if (0 > e) throw new Error('capacity must be greater than zero!');
                          this.$$capacity = e;
                        }
                        for (var t = {}; m.size() > this.$$capacity; ) t[m.peek().key] = this.remove(m.peek().key);
                        return t;
                      },
                      setDeleteOnExpire: function (e, t) {
                        if (null === e) delete this.$$deleteOnExpire;
                        else {
                          if (!o.isString(e)) throw new Error('deleteOnExpire must be a string!');
                          if ('none' !== e && 'passive' !== e && 'aggressive' !== e)
                            throw new Error('deleteOnExpire must be "none", "passive" or "aggressive"!');
                          this.$$deleteOnExpire = e;
                        }
                        t !== !1 && this.setRecycleFreq(this.$$recycleFreq);
                      },
                      setMaxAge: function (e) {
                        if (null === e) this.$$maxAge = Number.MAX_VALUE;
                        else {
                          if (!o.isNumber(e)) throw new Error('maxAge must be a number!');
                          if (0 > e) throw new Error('maxAge must be greater than zero!');
                          this.$$maxAge = e;
                        }
                        var t = void 0,
                          r = void 0,
                          i = void 0;
                        if (($.removeAll(), p)) {
                          var n = p().getItem('' + this.$$prefix + '.keys');
                          for (r = n ? o.fromJson(n) : [], t = 0; t < r.length; t++) {
                            i = r[t];
                            var c = p().getItem('' + this.$$prefix + '.data.' + i);
                            if (c) {
                              var l = o.fromJson(c);
                              this.$$maxAge === Number.MAX_VALUE
                                ? (l.expires = Number.MAX_VALUE)
                                : (l.expires = l.created + this.$$maxAge),
                                $.push({ key: i, expires: l.expires });
                            }
                          }
                        } else
                          for (r = a(s), t = 0; t < r.length; t++)
                            (i = r[t]),
                              this.$$maxAge === Number.MAX_VALUE
                                ? (s[i].expires = Number.MAX_VALUE)
                                : (s[i].expires = s[i].created + this.$$maxAge),
                              $.push(s[i]);
                        return 'aggressive' === this.$$deleteOnExpire ? this.removeExpired() : {};
                      },
                      setOnExpire: function (e) {
                        if (null === e) delete this.$$onExpire;
                        else {
                          if (!o.isFunction(e)) throw new Error('onExpire must be a function!');
                          this.$$onExpire = e;
                        }
                      },
                      setOptions: function (e, r) {
                        if (((e = e || {}), (r = !!r), !o.isObject(e)))
                          throw new Error('cacheOptions must be an object!');
                        'storagePrefix' in e
                          ? (this.$$storagePrefix = e.storagePrefix)
                          : r && (this.$$storagePrefix = t.storagePrefix),
                          (this.$$prefix = this.$$storagePrefix + this.$$id),
                          'disabled' in e ? (this.$$disabled = !!e.disabled) : r && (this.$$disabled = t.disabled),
                          'storageMode' in e || 'storageImpl' in e
                            ? this.setStorageMode(e.storageMode, e.storageImpl)
                            : r && this.setStorageMode(t.storageMode, t.storageImpl),
                          'storeOnResolve' in e
                            ? (this.$$storeOnResolve = !!e.storeOnResolve)
                            : r && (this.$$storeOnResolve = t.storeOnResolve),
                          'storeOnReject' in e
                            ? (this.$$storeOnReject = !!e.storeOnReject)
                            : r && (this.$$storeOnReject = t.storeOnReject),
                          'capacity' in e ? this.setCapacity(e.capacity) : r && this.setCapacity(t.capacity),
                          'deleteOnExpire' in e
                            ? this.setDeleteOnExpire(e.deleteOnExpire, !1)
                            : r && this.setDeleteOnExpire(t.deleteOnExpire, !1),
                          'maxAge' in e ? this.setMaxAge(e.maxAge) : r && this.setMaxAge(t.maxAge),
                          'recycleFreq' in e
                            ? this.setRecycleFreq(e.recycleFreq)
                            : r && this.setRecycleFreq(t.recycleFreq),
                          'cacheFlushInterval' in e
                            ? this.setCacheFlushInterval(e.cacheFlushInterval)
                            : r && this.setCacheFlushInterval(t.cacheFlushInterval),
                          'onExpire' in e ? this.setOnExpire(e.onExpire) : r && this.setOnExpire(t.onExpire);
                      },
                      setRecycleFreq: function (e) {
                        if (null === e) delete this.$$recycleFreq;
                        else {
                          if (!o.isNumber(e)) throw new Error('recycleFreq must be a number!');
                          if (0 > e) throw new Error('recycleFreq must be greater than zero!');
                          this.$$recycleFreq = e;
                        }
                        clearInterval(this.$$recycleFreqId),
                          'aggressive' === this.$$deleteOnExpire
                            ? !(function (e) {
                                e.$$recycleFreqId = setInterval(function () {
                                  e.removeExpired();
                                }, e.$$recycleFreq);
                              })(this)
                            : delete this.$$recycleFreqId;
                      },
                      setStorageMode: function (e, t) {
                        if (!o.isString(e)) throw new Error('storageMode must be a string!');
                        if ('memory' !== e && 'localStorage' !== e && 'sessionStorage' !== e)
                          throw new Error('storageMode must be "memory", "localStorage" or "sessionStorage"!');
                        var r = !1,
                          i = {};
                        if ('string' == typeof this.$$storageMode && this.$$storageMode !== e) {
                          var n = this.keys();
                          if (n.length) {
                            for (var s = 0; s < n.length; s++) i[n[s]] = this.get(n[s]);
                            for (s = 0; s < n.length; s++) this.remove(n[s]);
                            r = !0;
                          }
                        }
                        if (((this.$$storageMode = e), t)) {
                          if (!o.isObject(t)) throw new Error('storageImpl must be an object!');
                          if (!('setItem' in t && 'function' == typeof t.setItem))
                            throw new Error('storageImpl must implement "setItem(key, value)"!');
                          if (!('getItem' in t && 'function' == typeof t.getItem))
                            throw new Error('storageImpl must implement "getItem(key)"!');
                          if (!('removeItem' in t) || 'function' != typeof t.removeItem)
                            throw new Error('storageImpl must implement "removeItem(key)"!');
                          p = function () {
                            return t;
                          };
                        } else if ('localStorage' === this.$$storageMode)
                          try {
                            localStorage.setItem('angular-cache', 'angular-cache'),
                              localStorage.removeItem('angular-cache'),
                              (p = function () {
                                return localStorage;
                              });
                          } catch (a) {
                            (p = null), (this.$$storageMode = 'memory');
                          }
                        else if ('sessionStorage' === this.$$storageMode)
                          try {
                            sessionStorage.setItem('angular-cache', 'angular-cache'),
                              sessionStorage.removeItem('angular-cache'),
                              (p = function () {
                                return sessionStorage;
                              });
                          } catch (a) {
                            (p = null), (this.$$storageMode = 'memory');
                          }
                        if (r) for (var c in i) this.put(c, i[c]);
                      },
                      touch: function (e) {
                        var t = this;
                        if (e) {
                          var r = this.get(e, {
                            onExpire: function (e, r) {
                              return t.put(e, r);
                            }
                          });
                          r && this.put(e, r);
                        } else for (var i = this.keys(), n = 0; n < i.length; n++) this.touch(i[n]);
                      }
                    });
                  return v.setOptions(i, !0), v;
                };
              return (
                (i.createCache = s),
                (i.info = function () {
                  var t = a(n),
                    r = { size: t.length, caches: {} };
                  o.extend(r, e.defaults);
                  for (var i = 0; i < t.length; i++) {
                    var s = t[i];
                    r.caches[s] = n[s].info();
                  }
                  return r;
                }),
                (i.get = function (e) {
                  return n[e];
                }),
                (i.keySet = function () {
                  return u(n);
                }),
                (i.keys = function () {
                  return a(n);
                }),
                (i.destroy = function (e) {
                  n[e] && (n[e].destroy(), delete n[e]);
                }),
                (i.destroyAll = function () {
                  for (var e in n) n[e].destroy();
                  n = {};
                }),
                (i.clearAll = function () {
                  for (var e in n) n[e].removeAll();
                }),
                (i.removeExpiredFromAll = function () {
                  var e = {};
                  for (var t in n) e[t] = n[t].removeExpired();
                  return e;
                }),
                (i.enableAll = function () {
                  for (var e in n) n[e].$$disabled = !1;
                }),
                (i.disableAll = function () {
                  for (var e in n) n[e].$$disabled = !0;
                }),
                (i.touchAll = function () {
                  for (var e in n) n[e].touch();
                }),
                i
              );
            }
          ];
        };
      o.module('angular-cache', []).provider('BinaryHeap', p).provider('CacheFactory', $),
        (e.exports = 'angular-cache');
    },
    function (t, r, i) {
      t.exports = e;
    }
  ]);
});



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-network-cache/src/lib/angular-cache.js